import React from "react";
import { Switch, Route } from "react-router-dom";

import Home from "./pages/Home";
import Mint from "./pages/Mint";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/mint" component={Mint} />
    </Switch>
  );
}
